import { findCurrencySymbol } from "./find-currency-symbol"

const formatPrice = (value: number | null | undefined, currency: string, language: string): string => {
    const priceString = [
        Number.isInteger(value) || !value
            ? value
            : value.toLocaleString(language, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              }),
        findCurrencySymbol(currency),
    ]

    if (language === "en") {
        return priceString.reverse().join("")
    }

    // Join with non-breaking space as unicode \u00a0
    return priceString.join("\u00a0")
}

const formatIban = (number?: string): string | undefined => {
    if (!number) return
    return number.replace(/\s/g, "").replace(/∗+/, "∗∗∗∗∗∗∗∗∗")
}

export { formatPrice, formatIban }
